import {AttendanceTrackerAssignmentType} from '../backend/enums/attendance-tracker-assignment-type';
import {useAttendanceTrackerStatus} from '../contexts/attendance-tracker-status/context';
import {useAuth} from '../contexts/auth/context';
import {useCanTrackAttendance} from './use-can-track-attendance';

/**
 * Whether the attendance bar of the Daily Care Log is shown: always when the user must track attendance,
 * and only while a session is running when it is optional.
 */
export const useAttendanceOngoingBarVisible = (): boolean => {
  const {state} = useAuth();
  const canTrackAttendance = useCanTrackAttendance();
  const {isLoaded, openSession} = useAttendanceTrackerStatus();

  const isMandatory =
    state.session?.selectedAffiliation?.attendanceTracker?.assignment ===
    AttendanceTrackerAssignmentType.Mandatory;

  return canTrackAttendance && isLoaded && (!!openSession || isMandatory);
};
